export default __webpack_public_path__ + "00ab2b13a6343e221918b756e98385c4.svg";